<template>
  <v-container>
    <TitleParagraphRow :value="value" />

    <v-row justify="center">
      <v-col cols="auto">
        <LogoBar :value="items" invert />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
defineProps({
  items: {
    required: true,
    type: Array
  },
  value: {
    required: true,
    type: Object
  }
})
</script>
